module.exports = __webpack_public_path__ + "static/images/fu-loading.beeb359.gif";